import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";

// A quiz is answered once its card is in study: the first answer enrolls it. Derived from
// `user_card` + its quiz overlay, so the key is invalidated when either changes (the predicate is
// derived from the read's `with`).
const ANSWERED_QUIZ_KEYS_CONFIG = {
  columns: {},
  where: { fsrsCardId: { isNotNull: true } },
  with: { userQuizCard: { columns: { key: true } } },
} as const;

export function useGetAnsweredQuizKeysQueryKey() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (context) => context.db);
  const withTableChangeVersion = useActorTableChangeVersion("userCard", ANSWERED_QUIZ_KEYS_CONFIG);
  return () => withTableChangeVersion(["answeredQuizKeys", { actorDb }] as const);
}

/** The catalogue keys of every quiz whose card is in study, i.e. that the learner has answered. */
export const [useAnsweredQuizKeysQueryOptions, answeredQuizKeysQueryFn] = createUseQueryOptions(
  useGetAnsweredQuizKeysQueryKey,
  async ({ queryKey: [_, { actorDb }] }) => {
    // Soft-delete filter is injected by the wrapped `actorDb` query proxy.
    const studyCards = await actorDb(import.meta.location).query.userCard.findMany(
      ANSWERED_QUIZ_KEYS_CONFIG,
    );
    const answeredQuizKeys = new Set<string>();
    for (const studyCard of studyCards) {
      const key = studyCard.userQuizCard?.key;
      if (key !== undefined) {
        answeredQuizKeys.add(key);
      }
    }
    return answeredQuizKeys;
  },
);
